import { useQuery } from '@tanstack/react-query';
import { staffGet } from './client';
import type { OrgSearchResponse, OrgTab, OrgTabData } from './types';

/** Path after /v1/staff/orgs/:id for each tab. */
const TAB_PATHS: Record<OrgTab, string> = {
  overview: '',
  members: '/members',
  connections: '/connections',
  holds: '/holds',
  'stock-sync': '/stock-sync',
};

export const ORG_TABS = Object.keys(TAB_PATHS) as OrgTab[];

export const useOrgSearch = (q: string) =>
  useQuery({
    queryKey: ['staff', 'orgs', 'search', q],
    queryFn: () =>
      staffGet<OrgSearchResponse>(`/v1/staff/orgs?q=${encodeURIComponent(q)}`),
    enabled: q !== '',
  });

/** One GET per tab. */
export const useOrgTab = <K extends OrgTab>(orgId: string, tab: K) =>
  useQuery({
    queryKey: ['staff', 'orgs', orgId, tab],
    queryFn: () =>
      staffGet<OrgTabData[K]>(
        `/v1/staff/orgs/${encodeURIComponent(orgId)}${TAB_PATHS[tab]}`,
      ),
  });
